import type { SVGProps } from 'react';

import theme from '@styles/theme';

export const ChevronRight = ({
  width = 16,
  height = 16,
  stroke = theme.palette.text[11],
  strokeWidth = 1.1,
  className = '',
  ...otherProps
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    {...otherProps}
  >
    <path
      d='M6 12.6668L10.6667 8.00013L6 3.33346'
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
